import $ from 'jquery';

export default {

	init() {
		const carouselArticles = jQuery('.js-carousel-articles');

		if (carouselArticles.length > 0) {
			const settings = {
				dots: true,
				infinite: true,
				speed: 300,
				slidesToShow: 2.24,
				accessibility: true,
			};

			let isInitialized = false;

			function initCarousel() {
				const shouldInitialize = jQuery(window).width() >= 800;

				if (shouldInitialize && !isInitialized) {
					carouselArticles.slick(settings);
					isInitialized = true;
				} else if (!shouldInitialize && isInitialized) {
					carouselArticles.slick('unslick');
					isInitialized = false;
				}
			}

			initCarousel();

			jQuery(document).on('ready load', initCarousel);
			jQuery(window).on('resize', initCarousel);
		}
	}

};
